import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { PapiUser } from '@wix/da-papi-types';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import {
  DropdownOption,
  NullableDropdownGroup,
} from '@wix/da-shared-react/pkg/Dropdown/types';
import IconButtonWithContextMenu from '@wix/da-shared-react/pkg/Dropdown/Preset/IconButtonWithContextMenuV2';

export interface Props {
  profileOwnerUser: PapiUser;
  isGroupMember: boolean;
  isGroupFounder: boolean;
  canRespondToGroupNotifications: boolean;
  requestLeaveGroup: (group: PapiUser) => void;
  showCloseGroupModal: (group: PapiUser) => void;
}

const GroupMoreMenu: React.FC<Props> = ({
  canRespondToGroupNotifications,
  profileOwnerUser,
  isGroupMember,
  isGroupFounder,
  requestLeaveGroup,
  showCloseGroupModal,
}) => {
  const { t } = useTranslation();
  const menuItems: NullableDropdownGroup[] = [];

  const communicationMenuGroup = {
    items: [] as DropdownOption[],
  };
  const farewellMenuGroup = {
    items: [] as DropdownOption[],
  };

  if (canRespondToGroupNotifications) {
    communicationMenuGroup.items.push({
      label: t('groups.admin.groupNotifications'),
      link: Url.groupNotificationsLink(profileOwnerUser.userId),
    });
  }

  communicationMenuGroup.items.push({
    label: t('groups.sendInvite'),
  });

  if (isGroupMember) {
    farewellMenuGroup.items.push({
      label: t('groups.leaveGroup'),
      onClick: () => requestLeaveGroup(profileOwnerUser),
    });
  }

  if (isGroupFounder) {
    farewellMenuGroup.items.push({
      label: t('groups.admin.closeGroup'),
      onClick: () => showCloseGroupModal(profileOwnerUser),
    });
  }

  menuItems.push(communicationMenuGroup);
  menuItems.push(farewellMenuGroup);

  return (
    <IconButtonWithContextMenu
      size="large"
      items={menuItems}
      icon={EllipsisIcon}
      placement="bottom-end"
    />
  );
};
GroupMoreMenu.displayName = 'GroupMoreMenu';

export default GroupMoreMenu;
